import styled from '@emotion/styled';

export const ImageLogo = styled.img`
  width: 140px;
  height: 60px;
`;
